"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportingQuestionGroupingSessionDocument", {
    enumerable: true,
    get: function() {
        return ReportingQuestionGroupingSessionDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ReportingQuestionGroupingSessionDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    selectedQuestions: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        questions: _zod.z.array(_zod.z.string()),
        name: _zod.z.string(),
        is_grouped: _zod.z.boolean(),
        summary_function: _zod.z.string()
    })),
    createdAt: _zod.z.date(),
    updatedAt: _zod.z.date().nullable(),
    deletedAt: _zod.z.date().nullable(),
    reviewQueryID: _zod.z.instanceof(_bson.ObjectId),
    employeeQueryID: _zod.z.instanceof(_bson.ObjectId).nullish(),
    companyID: _zod.z.instanceof(_bson.ObjectId)
});
